export enum SHIPPING_ITEM_REFERENCE {
  SUJETO_PERITAJE = 0,
  PREVENTIVO = 1,
  VENTA_REPUESTO = 2,
  SIN_DEVOLUCION = 3,
}

export const ShippingItemReferenceString = {
  [SHIPPING_ITEM_REFERENCE.SUJETO_PERITAJE]: 'Sujeto a peritaje',
  [SHIPPING_ITEM_REFERENCE.PREVENTIVO]: 'Preventivo',
  [SHIPPING_ITEM_REFERENCE.VENTA_REPUESTO]: 'Venta de repuesto',
  [SHIPPING_ITEM_REFERENCE.SIN_DEVOLUCION]: 'Sin devolución',
};
